// ------------------ TAI KHOAN (ACCOUNTS/USERS) ------------------

import { ApiResponse, HTTaiKhoan, HTTaiKhoan_Wallet, OptionModel } from "src/types/api-response";
import { apiGet, apiPost, buildQueryString } from "./api-client";

export const accountApiService = {
    
  /**
   * Lấy danh sách option vai trò
   * GET /api/TaiKhoan/OptionVaiTro
   */

  async optionVaiTro(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      `/TaiKhoan/OptionVaiTro`,
      'TaiKhoan',
      'Lấy danh sách vai trò thất bại.'
    );
  },
 /**
   * Lấy danh sách option trạng thái tài khoản
   * GET /api/TaiKhoan/OptionTrangThaiTaiKhoan
   */

  async optionTrangThaiTaiKhoan(): Promise<ApiResponse<OptionModel>> {
    return apiGet<ApiResponse<OptionModel>>(
      `/TaiKhoan/OptionTrangThaiTaiKhoan`,
      'TaiKhoan',
      'Lấy danh sách trạng thái tài khoản thất bại.'
    );
  },

  /**
   * Lấy danh sách tài khoản
   * GET /api/TaiKhoan/ListTaiKhoan
   */
  async listTaiKhoan(params?: {
    Status?: 'TatCa' | 'DangDung' | 'TamNgung';
    rowCount?: number;
    Skip?: number;
    Top?: number;
    OrderBy?: string[];
    SearchBy?: string[];
  }): Promise<ApiResponse<HTTaiKhoan>> {
    const queryString = buildQueryString(params);
    return apiGet<ApiResponse<HTTaiKhoan>>(
      `/TaiKhoan/ListTaiKhoan${queryString}`,
      'TaiKhoan',
      'Lấy danh sách tài khoản thất bại.'
    );
  },

  /**
   * Lấy thông tin tài khoản theo ID
   * GET /api/TaiKhoan/GetTaiKhoanById/{id}
   */
  async getTaiKhoanById(id: string): Promise<ApiResponse<HTTaiKhoan>> {
    return apiGet<ApiResponse<HTTaiKhoan>>(
      `/TaiKhoan/GetTaiKhoanById/${id}`,
      'TaiKhoan',
      'Lấy thông tin tài khoản thất bại.'
    );
  },

  /**
   * Cập nhật thông tin tài khoản theo ID
   * POST /api/TaiKhoan/EditTaiKhoanById/{id}
   */
  async updateTaiKhoanById(id: string, accountData: Partial<HTTaiKhoan>): Promise<ApiResponse<HTTaiKhoan>> {
    return apiPost<ApiResponse<HTTaiKhoan>>(
      `/TaiKhoan/EditTaiKhoanById/${id}`,
      accountData,
      'TaiKhoan',
      false,
      'Cập nhật tài khoản thất bại.'
    );
  },

  /**
   * Đổi mật khẩu cho một tài khoản cụ thể (Admin dùng)
   * POST /api/TaiKhoan/EditPasswordById/{id}
   */
  async updatePasswordById(id: string, newPassword: string): Promise<ApiResponse<HTTaiKhoan>> {
    return apiPost<ApiResponse<HTTaiKhoan>>(
      `/TaiKhoan/EditPasswordById/${id}`,
      newPassword, // Truyền string trực tiếp theo schema
      'TaiKhoan',
      false,
      'Cập nhật mật khẩu thất bại.'
    );
  },

  /**
   * Lấy thông tin tài khoản của chính mình (đang đăng nhập)
   * GET /api/TaiKhoan/GetMyTaiKhoan
   */
  async getMyTaiKhoan(): Promise<ApiResponse<HTTaiKhoan>> { 
    return apiGet<ApiResponse<HTTaiKhoan>>(
      '/TaiKhoan/GetMyTaiKhoan',
      'TaiKhoan',
      'Lấy thông tin cá nhân thất bại.'
    );
  },

  /**
   * Cập nhật thông tin tài khoản cá nhân
   * POST /api/TaiKhoan/EditMyTaiKhoan
   */
  async updateMyTaiKhoan(accountData: Partial<HTTaiKhoan>): Promise<ApiResponse<HTTaiKhoan>> {
    return apiPost<ApiResponse<HTTaiKhoan>>(
      '/TaiKhoan/EditMyTaiKhoan',
      accountData,
      'TaiKhoan',
      false,
      'Cập nhật thông tin cá nhân thất bại.'
    );
  },

  /**
   * Tự đổi mật khẩu cá nhân
   * POST /api/TaiKhoan/EditMyPassword
   */
  async updateMyPassword(accountData: Partial<HTTaiKhoan>): Promise<ApiResponse<HTTaiKhoan>> {
    return apiPost<ApiResponse<HTTaiKhoan>>(
      '/TaiKhoan/EditMyPassword',
      accountData,
      'TaiKhoan',
      false,
      'Đổi mật khẩu thất bại.'
    );
  },


  /**
   * POST /api/HeThong/ConnectionWallet
   */

  async connectionWallet(addressWallet: String): Promise<ApiResponse<HTTaiKhoan_Wallet>>{
    return apiPost<ApiResponse<HTTaiKhoan_Wallet>>(
      `/HeThong/ConectionWallet?addressWallet=${addressWallet}`,
      null,
      'HeThong',
      false, 
      'Cập nhật địa chỉ ví thất bại.' 
    );
  }
};